import { Fragment } from 'react';
import type { ReactNode } from 'react';
import type { DataTableGrouping } from './types';

// The grouped tbody: a divider on each group change; collapsed groups keep
// their divider but skip their data rows. Both apply only while dividers show.
export function buildGroupedRows<T>(
    rows: readonly T[],
    grouping: DataTableGrouping<T>,
    colSpan: number,
    rowNode: (row: T, index: number) => ReactNode
): ReactNode[] {
    const showDividers = grouping.showDividers?.(rows) ?? true;
    const elements: ReactNode[] = [];
    let prevGroup: string | null = null;
    for (const [index, row] of rows.entries()) {
        const groupKey = grouping.getGroupKey(row);
        if (showDividers && groupKey !== prevGroup) {
            elements.push(
                <Fragment key={`group-${groupKey}`}>
                    {grouping.renderDivider(groupKey, colSpan, prevGroup)}
                </Fragment>
            );
            prevGroup = groupKey;
        }
        if (showDividers && grouping.collapsed?.[groupKey]) continue;
        elements.push(rowNode(row, index));
    }
    return elements;
}
